// Auto-reload when dynamic import fails (stale chunks after deployment)
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

// FIRST import, deliberately.
//
// It patches axios so every client carries the signed token, and it has to run
// before any module creates its own axios instance at import time - otherwise
// that client is built unpatched and its requests arrive unauthenticated, which
// the server runs UNRESTRICTED across every tenant. Moving this line down the
// list silently reintroduces that.
import installTenantAuth from './plugins/tenantAuth'
installTenantAuth()

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
// import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import PickList from 'primevue/picklist'
import VirtualScroller from 'primevue/virtualscroller'
import Sidebar from 'primevue/sidebar'
import Column from 'primevue/column'
import ConfirmDialog from 'primevue/confirmdialog'
import Steps from 'primevue/steps'
import { i18n } from './i18n'
import App from './App.vue'
import Aura from '@primevue/themes/aura'
import router from './router'
import axios from './plugins/axios'
import './plugins/vee-validate' // Import vee-validate rules

// Import all ONE components
// Button components
import ONEButton from './components/primevuecomponents/button/ONEButton/ONEButton.vue'
import ONESplitButton from './components/primevuecomponents/button/ONESplitButton/ONESplitButton.vue'

// Data components
import ONECarousel from './components/primevuecomponents/data/ONECarousel/ONECarousel.vue'
import ONEDataTable from './components/primevuecomponents/data/ONEDataTable/ONEDataTable.vue'
import ONEDataView from './components/primevuecomponents/data/ONEDataView/ONEDataView.vue'
import ONEOrderList from './components/primevuecomponents/data/ONEOrderList/ONEOrderList.vue'
import ONEOrganizationChart from './components/primevuecomponents/data/ONEOrganizationChart/ONEOrganizationChart.vue'
import ONEPaginator from './components/primevuecomponents/data/ONEPaginator/ONEPaginator.vue'
import ONEPickList from './components/primevuecomponents/data/ONEPickList/ONEPickList.vue'
import ONETimeline from './components/primevuecomponents/data/ONETimeline/ONETimeline.vue'
import ONETree from './components/primevuecomponents/data/ONETree/ONETree.vue'
import ONETreeTable from './components/primevuecomponents/data/ONETreeTable/ONETreeTable.vue'
import ONEVirtualScroller from './components/primevuecomponents/data/ONEVirtualScroller/ONEVirtualScroller.vue'
import ONETableSkeleton from './components/ONELoader/ONETableSkeleton.vue'
import ONEAdvancedDataTable from './components/advancedComponents/data/ONEAdvancedDataTable.vue'

// Form components
import ONEAutocomplete from './components/primevuecomponents/form/ONEAutocomplete/ONEAutocomplete.vue'
import ONECascadeSelect from './components/primevuecomponents/form/ONECascadeSelect/ONECascadeSelect.vue'
import ONECheckbox from './components/primevuecomponents/form/ONECheckbox/ONECheckbox.vue'
import ONEColorPicker from './components/primevuecomponents/form/ONEColorPicker/ONEColorPicker.vue'
import ONEDatepicker from './components/primevuecomponents/form/ONEDatepicker/ONEDatepicker.vue'
import ONEDropdown from './components/primevuecomponents/form/ONEDropdown/ONEDropdown.vue'
import ONEEditor from './components/primevuecomponents/form/ONEEditor/ONEEditor.vue'
import ONEFileUpload from './components/primevuecomponents/form/ONEFileUpload/ONEFileUpload.vue'
import ONEInputGroup from './components/primevuecomponents/form/ONEInputGroup/ONEInputGroup.vue'
import ONEInputIcon from './components/primevuecomponents/form/ONEInputIcon/ONEInputIcon.vue'
import ONEInputMask from './components/primevuecomponents/form/ONEInputMask/ONEInputMask.vue'
import ONEInputNumber from './components/primevuecomponents/form/ONEInputNumber/ONEInputNumber.vue'
import ONEInputOTP from './components/primevuecomponents/form/ONEInputOTP/ONEInputOTP.vue'
import ONEInputSwitch from './components/primevuecomponents/form/ONEInputSwitch/ONEInputSwitch.vue'
import ONEInputText from './components/primevuecomponents/form/ONEInputText/ONEInputText.vue'
import ONEKnob from './components/primevuecomponents/form/ONEKnob/ONEKnob.vue'
import ONEListbox from './components/primevuecomponents/form/ONEListbox/ONEListbox.vue'
import ONEMultiSelect from './components/primevuecomponents/form/ONEMultiSelect/ONEMultiSelect.vue'
import ONEPassword from './components/primevuecomponents/form/ONEPassword/ONEPassword.vue'
import ONERadioButton from './components/primevuecomponents/form/ONERadioButton/ONERadioButton.vue'
import ONERating from './components/primevuecomponents/form/ONERating/ONERating.vue'
import ONESelectButton from './components/primevuecomponents/form/ONESelectButton/ONESelectButton.vue'
import ONESlider from './components/primevuecomponents/form/ONESlider/ONESlider.vue'
import ONESpinButton from './components/primevuecomponents/form/ONESpinButton/ONESpinButton.vue'
import ONETextarea from './components/primevuecomponents/form/ONETextarea/ONETextarea.vue'
import ONEToggleButton from './components/primevuecomponents/form/ONEToggleButton/ONEToggleButton.vue'
import ONETreeSelect from './components/primevuecomponents/form/ONETreeSelect/ONETreeSelect.vue'
import ONETriStateCheckbox from './components/primevuecomponents/form/ONETriStateCheckbox/ONETriStateCheckbox.vue'

// Media components
import ONEGalleria from './components/primevuecomponents/media/ONEGalleria/ONEGalleria.vue'
import ONEImage from './components/primevuecomponents/media/ONEImage/ONEImage.vue'

// Menu components
import ONEBreadcrumb from './components/primevuecomponents/menu/ONEBreadcrumb/ONEBreadcrumb.vue'
import ONEContextMenu from './components/primevuecomponents/menu/ONEContextMenu/ONEContextMenu.vue'
import ONEDock from './components/primevuecomponents/menu/ONEDock/ONEDock.vue'
import ONEMegaMenu from './components/primevuecomponents/menu/ONEMegaMenu/ONEMegaMenu.vue'
import ONEMenu from './components/primevuecomponents/menu/ONEMenu/ONEMenu.vue'
import ONEMenuBar from './components/primevuecomponents/menu/ONEMenuBar/ONEMenuBar.vue'
import ONEPanelMenu from './components/primevuecomponents/menu/ONEPanelMenu/ONEPanelMenu.vue'
import ONETabMenu from './components/primevuecomponents/menu/ONETabMenu/ONETabMenu.vue'
import ONETieredMenu from './components/primevuecomponents/menu/ONETieredMenu/ONETieredMenu.vue'

// Messages components
import ONEInlineMessage from './components/primevuecomponents/messages/ONEInlineMessage/ONEInlineMessage.vue'
import ONEToast from './components/primevuecomponents/messages/ONEToast/ONEToast.vue'

// Misc components
import ONEAvatar from './components/primevuecomponents/misc/ONEAvatar/ONEAvatar.vue'
import ONEAvatarGroup from './components/primevuecomponents/misc/ONEAvatar/ONEAvatarGroup.vue'
import ONEBadge from './components/primevuecomponents/misc/ONEBadge/ONEBadge.vue'
import ONEOverlayBadge from './components/primevuecomponents/misc/ONEBadge/ONEOverlayBadge.vue'
import ONEMeterGroup from './components/primevuecomponents/misc/ONEMeterGroup/ONEMeterGroup.vue'
import ONEProgressBar from './components/primevuecomponents/misc/ONEProgressBar/ONEProgressBar.vue'
import ONEProgressSpinner from './components/primevuecomponents/misc/ONEProgressSpinner/ONEProgressSpinner.vue'
import ONEBlockUI from './components/primevuecomponents/misc/ONEBlockUI/ONEBlockUI.vue'
import ONEChip from './components/primevuecomponents/misc/ONEChip/ONEChip.vue'
import ONEInplace from './components/primevuecomponents/misc/ONEInplace/ONEInplace.vue'
import ONERipple from './components/primevuecomponents/misc/ONERipple/ONERipple.vue'
import ONEScrollTop from './components/primevuecomponents/misc/ONEScrollTop/ONEScrollTop.vue'
import ONESkeleton from './components/primevuecomponents/misc/ONESkeleton/ONESkeleton.vue'
import ONETag from './components/primevuecomponents/misc/ONETag/ONETag.vue'
import ONETerminal from './components/primevuecomponents/misc/ONETerminal/ONETerminal.vue'
import ONETableEmpty from './components/Empty state/ONETableEmpty.vue'

// Overlay components
import ONEConfirmPopup from './components/primevuecomponents/overlay/ONEConfirmPopup/ONEConfirmPopup.vue'
import ONEDialog from './components/primevuecomponents/overlay/ONEDialog/ONEDialog.vue'
import ONEDrawer from './components/primevuecomponents/overlay/ONEDrawer/ONEDrawer.vue'
import ONEPopover from './components/primevuecomponents/overlay/ONEPopover/ONEPopover.vue'
import ONETooltip from './components/primevuecomponents/overlay/ONETooltip/ONETooltip.vue'

// Panel components
import ONEAccordion from './components/primevuecomponents/panel/ONEAccordion/ONEAccordion.vue'
import ONEAccordionTab from './components/primevuecomponents/panel/ONEAccordion/ONEAccordionTab.vue'
import ONECard from './components/primevuecomponents/panel/ONECard/ONECard.vue'
import ONEDivider from './components/primevuecomponents/panel/ONEDivider/ONEDivider.vue'
import ONEFieldset from './components/primevuecomponents/panel/ONEFieldset/ONEFieldset.vue'
import ONEPanel from './components/primevuecomponents/panel/ONEPanel/ONEPanel.vue'
import ONEScrollPanel from './components/primevuecomponents/panel/ONEScrollPanel/ONEScrollPanel.vue'
import ONESplitter from './components/primevuecomponents/panel/ONESplitter/ONESplitter.vue'
import ONESplitterPanel from './components/primevuecomponents/panel/ONESplitter/ONESplitterPanel.vue'
import ONEStepper from './components/primevuecomponents/panel/ONEStepper/ONEStepper.vue'
import ONETabView from './components/primevuecomponents/panel/ONETabView/ONETabView.vue'
import ONETabPanel from './components/primevuecomponents/panel/ONETabView/ONETabPanel.vue'
import ONEToolbar from './components/primevuecomponents/panel/ONEToolbar/ONEToolbar.vue'
import ONESuccessDialog from './components/primevuecomponents/ONESuccess/ONESuccessDialog.vue'
// Design tokens first — 3,173 var(--one-*) references across the app depend on
// these existing. Must load before any stylesheet that consumes them.
import './assets/one-tokens.css'
import './assets/main.scss'
import 'primeicons/primeicons.css'
import 'tailwindcss-primeui'
// App-wide compact (medium) density — applies to every page.
import './assets/compact-density.css'
import './assets/one-theme.css'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

const app = createApp(App)

// Add plugins
app.use(createPinia())
app.use(PrimeVue, {
  theme: {
    preset: Aura
  }
})
app.use(ToastService)
app.use(ConfirmationService)
app.use(i18n)
app.use(router)

// Make axios instance available globally
app.config.globalProperties.$axios = axios

// Register directives
app.directive('tooltip', Tooltip)
app.directive('ripple', ONERipple)

// Register base PrimeVue components
app.component('PickList', PickList)
app.component('VirtualScroller', VirtualScroller)
app.component('Sidebar', Sidebar)

// Register ONE components
// Button components
app.component('ONEButton', ONEButton)
app.component('ONESplitButton', ONESplitButton)

// Data components
app.component('ONECarousel', ONECarousel)
app.component('ONEDataTable', ONEDataTable)
app.component('ONEDataView', ONEDataView)
app.component('ONEOrderList', ONEOrderList)
app.component('ONEOrganizationChart', ONEOrganizationChart)
app.component('ONEPaginator', ONEPaginator)
app.component('ONEPickList', ONEPickList)
app.component('ONETimeline', ONETimeline)
app.component('ONETree', ONETree)
app.component('ONETreeTable', ONETreeTable)
app.component('ONEVirtualScroller', ONEVirtualScroller)
app.component('ONETableEmpty', ONETableEmpty)
app.component('ONETableSkeleton', ONETableSkeleton)

// Form components
app.component('ONEAutocomplete', ONEAutocomplete)
app.component('ONECascadeSelect', ONECascadeSelect)
app.component('ONECheckbox', ONECheckbox)
app.component('ONEColorPicker', ONEColorPicker)
app.component('ONEDatepicker', ONEDatepicker)
app.component('ONEDropdown', ONEDropdown)
app.component('ONEEditor', ONEEditor)
app.component('ONEFileUpload', ONEFileUpload)
app.component('ONEInputGroup', ONEInputGroup)
app.component('ONEInputIcon', ONEInputIcon)
app.component('ONEInputMask', ONEInputMask)
app.component('ONEInputNumber', ONEInputNumber)
app.component('ONEInputOTP', ONEInputOTP)
app.component('ONEInputSwitch', ONEInputSwitch)
app.component('ONEInputText', ONEInputText)
app.component('ONEKnob', ONEKnob)
app.component('ONEListbox', ONEListbox)
app.component('ONEMultiSelect', ONEMultiSelect)
app.component('ONEPassword', ONEPassword)
app.component('ONERadioButton', ONERadioButton)
app.component('ONERating', ONERating)
app.component('ONESelectButton', ONESelectButton)
app.component('ONESlider', ONESlider)
app.component('ONESpinButton', ONESpinButton)
app.component('ONETextarea', ONETextarea)
app.component('ONEToggleButton', ONEToggleButton)
app.component('ONETreeSelect', ONETreeSelect)
app.component('ONETriStateCheckbox', ONETriStateCheckbox)

// Media components
app.component('ONEGalleria', ONEGalleria)
app.component('ONEImage', ONEImage)

// Menu components
app.component('ONEBreadcrumb', ONEBreadcrumb)
app.component('ONEContextMenu', ONEContextMenu)
app.component('ONEDock', ONEDock)
app.component('ONEMegaMenu', ONEMegaMenu)
app.component('ONEMenu', ONEMenu)
app.component('ONEMenuBar', ONEMenuBar)
app.component('ONEPanelMenu', ONEPanelMenu)
app.component('ONETabMenu', ONETabMenu)
app.component('ONETieredMenu', ONETieredMenu)

// Messages components
app.component('ONEInlineMessage', ONEInlineMessage)
app.component('ONEToast', ONEToast)

// Misc components
app.component('ONEAvatar', ONEAvatar)
app.component('ONEAvatarGroup', ONEAvatarGroup)
app.component('ONEBadge', ONEBadge)
app.component('ONEOverlayBadge', ONEOverlayBadge)
app.component('ONEMeterGroup', ONEMeterGroup)
app.component('ONEProgressBar', ONEProgressBar)
app.component('ONEProgressSpinner', ONEProgressSpinner)
app.component('ONEBlockUI', ONEBlockUI)
app.component('ONEChip', ONEChip)
app.component('ONEInplace', ONEInplace)
app.component('ONEScrollTop', ONEScrollTop)
app.component('ONESkeleton', ONESkeleton)
app.component('ONETag', ONETag)
app.component('ONETerminal', ONETerminal)

// Overlay components
app.component('ONEConfirmPopup', ONEConfirmPopup)
app.component('ONEDialog', ONEDialog)
app.component('ONEDrawer', ONEDrawer)
app.component('ONEPopover', ONEPopover)
app.component('ONETooltip', ONETooltip)

// Panel components
app.component('ONEAccordion', ONEAccordion)
app.component('ONEAccordionTab', ONEAccordionTab)
app.component('ONECard', ONECard)
app.component('ONEDivider', ONEDivider)
app.component('ONEFieldset', ONEFieldset)
app.component('ONEPanel', ONEPanel)
app.component('ONEScrollPanel', ONEScrollPanel)
app.component('ONESplitter', ONESplitter)
app.component('ONESplitterPanel', ONESplitterPanel)
app.component('ONEStepper', ONEStepper)

app.component('ONETabView', TabView)
app.component('ONETabPanel', TabPanel)
app.component('ONEToolbar', ONEToolbar)
app.component('ONESuccessDialog', ONESuccessDialog)

/**
 * Aliases for names the screens already use but which were never registered.
 * Vue silently renders an unknown component as an inert custom element, so these
 * were not errors — the controls simply did not exist: 282 <ONEColumn> meant
 * whole tables rendered with no columns, and 66 <ONECalendar> meant date fields
 * with no picker. Registering the alias fixes every call site at once.
 */
app.component('ONEAdvancedDataTable', ONEAdvancedDataTable)
app.component('ONEColumn', Column)
app.component('ONEConfirmDialog', ConfirmDialog)
app.component('ONECalendar', ONEDatepicker)
app.component('ONEDatePicker', ONEDatepicker)   // capital P variant
app.component('ONESelect', ONEDropdown)
app.component('ONEModal', ONEDialog)
app.component('ONEInput', ONEInputText)
app.component('ONESwitch', ONEInputSwitch)
app.component('ONEMessage', ONEInlineMessage)
app.component('ONESidebar', ONEDrawer)
app.component('ONEPagination', ONEPaginator)
// PrimeVue has two: Stepper (value + StepList/StepPanels children) and the legacy
// Steps (:model + activeStep). Both call sites use the legacy API, and aliasing to
// Stepper sent <BaseTransition> into a 'Maximum recursive updates exceeded' loop.
app.component('ONESteps', Steps)

// Global event listener to prevent Enter key from triggering submit buttons
document.addEventListener('keydown', (event) => {
  if (event.key === 'Enter') {
    const target = event.target as HTMLElement

    // Check if the target is an input, textarea, or other form element
    if (target && (
      target.tagName === 'INPUT' ||
      target.tagName === 'TEXTAREA' ||
      target.tagName === 'SELECT' ||
      target.contentEditable === 'true'
    )) {
      // Check if it's not a submit button or button input
      if (target.tagName === 'INPUT') {
        const inputElement = target as HTMLInputElement
        if (inputElement.type === 'submit' || inputElement.type === 'button') {
          return // Allow submit buttons to work normally
        }
      }

      // Prevent the default form submission behavior
      const form = target.closest('form')
      if (form) {
        event.preventDefault()
        event.stopPropagation()
      }
    }
  }
})

// Mount the app
app.mount('#app')
